<template>
  <button
    :class="buttonStyle"
    class="px-5 py-3 text-sm whitespace-nowrap rounded-md border font-semibold"
    type="submit"
    :disabled="isInactive"
    :aria-busy="loading ? 'true' : 'false'"
    @click="handleClick"
  >
    <span class="inline-flex items-center justify-center gap-2">
      <LoadingSymbol v-if="loading" size="1x" />
      <slot></slot>
    </span>
  </button>
</template>

<script>
import BaseVariantComponent from "@/components/common/BaseVariantComponent.vue";
import LoadingSymbol from "@/components/common/LoadingSymbol.vue";

export default {
  name: "Button",
  components: { LoadingSymbol },
  mixins: [BaseVariantComponent],

  props: {
    loading: { default: false },
  },

  data() {
    return {
      variantStyles: {
        // Solid highlight so the primary action clearly outranks the
        // surfaces around it (inputs/cards share bg-primary-500).
        // Dark text on orange keeps the label above 4.5:1 contrast.
        default:
          "bg-highlight hover:bg-orange-400 text-primary-700 border-highlight hover:border-orange-400",
        disabled:
          "bg-primary-500 text-subtle opacity-60 border-primary-400 cursor-not-allowed",
        success: "bg-green-500 text-white border-green-500 hover:bg-green-600",
        warning: "bg-orange-500 text-white border-orange-500",
        danger: "bg-red-500 text-white border-red-500 hover:bg-red-600",
      },
    };
  },

  computed: {
    // A loading button is not clickable, so it reads as disabled too.
    isInactive() {
      return Boolean(this.disabled) || Boolean(this.loading);
    },
    buttonStyle() {
      return this.isInactive ? this.variantStyles.disabled : this.variantStyle;
    },
  },

  methods: {
    handleClick(event) {
      if (!this.loading) {
        this.$emit("click", event);
      }
    },
  },
};
</script>
